export const setSelectedMod = (mode) => ({
    type: 'SET_THEME_MODE',
    payload: mode
});

export const setThemeColor = (color) => ({
    type: 'SET_THEME_COLOR',
    payload: color
});

export const setBorderStroke = (stroke) => ({
    type: 'SET_BORDER_STROKE',
    payload: stroke
});

export const setBodyGradient = (gradient) => ({
    type: 'SET_BODY_GRADIENT',
    payload: gradient
});

export const setBoxLayout = (layout) => ({
    type: 'SET_BOX_LAYOUT',
    payload: layout
});

export const setMonoChrome = (monochrome) => ({
    type: 'SET_MONOCHROME',
    payload: monochrome
});

export const setBorderRadius = (radius) => ({
    type: 'SET_BORDER_RADIUS',
    payload: radius
});

export const setIconColor = (color) => ({
    type: 'SET_ICON_COLOR',
    payload: color
});

export const setCardShadow = (shadow) => ({
    type: 'SET_CARD_SHADOW',
    payload: shadow
});

export const setSidebarDark = (sidebarDark) => ({
    type: 'SET_SIDEBAR_DARK',
    payload: sidebarDark
});

export const setHeaderDark = (headerDark) => ({
    type: 'SET_HEADER_DARK',
    payload: headerDark
});

// Actions for handling theme settings data from API
export const setThemeSettingsData = (themeData) => ({
    type: 'SET_THEME_SETTINGS_DATA',
    payload: themeData
});

export const setThemeSettingsLoading = (loading) => ({
    type: 'SET_THEME_SETTINGS_LOADING',
    payload: loading
});

export const setThemeSettingsError = (error) => ({
    type: 'SET_THEME_SETTINGS_ERROR',
    payload: error
});
export const setMenuAccess = (menus) => ({
    type: "SET_MENUACCESS",
    payload: menus, // expects [{}, {}, {}]
  });
  
  export const removeMenuAccess = () => ({
    type: "REMOVE_MENUACCESS",
  });
  
  export const setMenuList = (menus) => ({
    type: "SET_MENULIST",
    payload: menus, // expects [{}, {}, {}]
  });
  
  export const removeMenuList = () => ({
    type: "REMOVE_MENULIST",
  });